// src/searchParams/searchParams.ts
function e(e) {
	return Object.keys(e).reduce((t, n) => {
		let r = e[n];
		return r !== void 0 && (r instanceof Array ? r : [r]).forEach((e) => t.append(n, e.toString())), t;
	}, new URLSearchParams());
}
function t(e) {
	return [...new URLSearchParams(e).entries()].reduce((e, [t, n]) => {
		let r = e[t];
		return {
			...e,
			[t]: r === void 0 ? n : r instanceof Array ? [...r, n] : [r, n]
		};
	}, {});
}
export { e as searchParamsToURLSearchParams, t as searchStringToParams };

//# sourceMappingURL=index.js.map